import { Localized } from "@fluent/react/compat";
import React, { FunctionComponent, useCallback, useState } from "react";

import {
  Flex,
  HorizontalGutter,
  Icon,
  Tab,
  TabBar,
} from "coral-ui/components/v2";

import styles from "./ModerateCard.css";
 
interface Props {
  status: string;
  reasons: string[];
}

type DetailsTabs = "STATUS" | "REASONS";

// Format reason strings: replace underscores with spaces and capitalize only first word
const formatText = (text: string) => {
  return text.replace(/_/g, " ");
};

const ImageDetailsContainer: FunctionComponent<Props> = ({
  status,
  reasons,
}) => {
  const [activeTab, setActiveTab] = useState<DetailsTabs>("STATUS");
  const onTabClick = useCallback((id) => setActiveTab(id as DetailsTabs), [
    setActiveTab,
  ]);

  return (
    <HorizontalGutter>
      <TabBar variant="default" activeTab={activeTab} onTabClick={onTabClick}>
        <Tab tabID="STATUS" classes={styles}>
          <Flex alignItems="center" itemGutter>
            <Icon size="md">info</Icon>
            <Localized id="moderateCardDetails-tab-status">
              <span>Status</span>
            </Localized>
          </Flex>
        </Tab>
        <Tab tabID="REASONS" classes={styles}>
          <Flex alignItems="center" itemGutter>
            <Icon size="md">list</Icon>
            <Localized id="moderateCardDetails-tab-reasons">
              <span>Reasons</span>
            </Localized>
          </Flex>
        </Tab>
      </TabBar>
      
      {activeTab === "STATUS" && (
        <div className={styles.content}>
          <div>{formatText(status)}</div>
        </div>
      )}
      
      {activeTab === "REASONS" && (
        <div className={styles.content}>
          {reasons && reasons.length > 0 ? (
            reasons.map((reason, index) => (
              <div key={index}>{formatText(reason)}</div>
            ))
          ) : (
            <div>No reasons provided</div>
          )}
        </div>
      )}
    </HorizontalGutter>
  );
};

export default ImageDetailsContainer;
